import React, {useEffect, useState} from "react"
import { StaticQuery, graphql } from "gatsby"
import {TopNavigation} from "../helpers/navigation"
import "./header.scss"

const Header = ({useSimpleHeader}) => {
    const [navActive, setNavActive] = useState(false)
    const [navFixed, setNavFixed] = useState(false);

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 50) {
                setNavFixed(true)
            } else {
                setNavFixed(false)
            }
        })
    })

    const getFormattedNavigationNodes = (nodes) => {
        var map = {}, node, roots = [], i;

        for (i = 0; i < nodes.length; i += 1) {
            map[nodes[i].key] = i; // initialize the map
            nodes[i].remoteChildren = []; // initialize the children
        }

        for (i = 0; i < nodes.length; i += 1) {
            node = nodes[i];
            if (node.remoteParent) {
                // if you have dangling branches check that map[node.parentId] exists
                nodes[map[node.remoteParent.uid]].remoteChildren.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }


    return (
        <StaticQuery
            query={graphql`{
              craftHeaderGlobalSet {
                headerLogo {
                  url
                  alt
                }
              }
              navigation: allCraftHeaderNavigationNode(sort: {fields: lft}) {
                nodes {
                    key: uid
                    nodeUri
                    title
                    enabled
                    remoteParent {
                        uid
                    }
                }
              }
            }`}
            render={data => {
                if (!useSimpleHeader) {
                    return <header id="main-header" className={(navFixed) ? 'fixed': ''}>
                        <div className="container d-flex justify-content-between align-items-center position-relative">
                            <div className="logo-container">
                                <a href="https://www.cordiance.com">
                                    <img src={data.craftHeaderGlobalSet.headerLogo[0].url} width="221" height="48" alt={data.craftHeaderGlobalSet.headerLogo[0].alt} id="logo"/>
                                </a>
                            </div>
                            <div className="navbar-expand-lg navbar ">
                                <button className="navbar-toggler" type="button" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation" onClick={() => setNavActive(!navActive)}>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </button>
                                <div className={`navbar-collapse ${navActive ? '' : 'collapse'}`} id="navbarSupportedContent">
                                    <ul className="navbar-nav" id="top-menu">
                                        {TopNavigation(getFormattedNavigationNodes(data.navigation.nodes))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </header>
                } else {
                    return <header id="main-header" className={(navFixed) ? 'fixed': ''}>
                        <div className="container d-flex justify-content-center align-items-center position-relative simple-header">
                            <a href="https://www.cordiance.com">
                                <img src={data.craftHeaderGlobalSet.headerLogo[0].url} width="221" height="48" alt={data.craftHeaderGlobalSet.headerLogo[0].alt} id="logo"/>
                            </a>
                        </div>
                    </header>
                }
            }}
        />
    )
}

export default Header